var map = {
	"./schriftzug_dark.svg": 3421,
	"./schriftzug_demo.svg": 7053,
	"./schriftzug_development.svg": 7048,
	"./schriftzug_gebendigital_dark.svg": 3156,
	"./schriftzug_gebendigital_development.svg": 6874,
	"./schriftzug_gebendigital_production.svg": 3652,
	"./schriftzug_kirchgeld_digital.svg": 9977,
	"./schriftzug_kirchgeld_digital_dark.svg": 6047,
	"./schriftzug_production.svg": 8749,
	"./schriftzug_spendenbescheinigung_digital.svg": 7891,
	"./schriftzug_spendenbescheinigung_digital_dark.svg": 2723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2315;